import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

/**
 * ATTENZIONE:
 * Questo componente può essere usato nei widget di varie versioni.
 * OGNI MODIFICA COMPORTA LA MODIFICA NEI WIDGET CHE LO UTILIZZERANNO
 *
 * VOLUTAMENTE E' UN SEMPLICE SELECT, NON AGGIUNGERE FUNZIONALITA'
 */
@Component({
  selector: 'pt-widget-select',
  template: `
    <div
      class="form-control form-control-sm ng-select-single-control"
      [class.is-invalid]="isRequired && !currentValueUUID"
      [class.ng-invalid]="isRequired && !currentValueUUID">
      <ng-select appendTo='body'
                 [disabled]='disabled'
                 bindValue='uuid'
                 [ngStyle]='{ width: width}'
                 [searchable]='searchable'
                 bindLabel='label'
                 [clearable]='cleanable'
                 class='ng-select--custom'
                 [(ngModel)]='currentValueUUID'
                 (ngModelChange)='changeSelectedValue($event)'
                 [items]='items'>
<!--        [ngStyle]='{width: widthLabel}'-->

        <!--            style="width: calc(100% - 55px);"-->

        <ng-template ng-label-tmp let-item='item'>
          <div
            class='w-100 text-ellipsis'
            placement='top'
            container='body'
            ngbTooltip='{{item.label}}'>
            {{ item.label }}
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item='item' let-index='index' let-search='searchTerm'>
          <div
            class='w-100 text-ellipsis'
            placement='top'
            container='body'
            ngbTooltip='{{item.label}}'>
            {{ item.label }}
          </div>
        </ng-template>
      </ng-select>
    </div>
  `
})
export class WidgetSelectComponent implements OnChanges {

  @Input() selectedValue: WidgetSelectValue;
  @Input() items: WidgetSelectValue[];
  @Input() disabled = false;
  @Input() cleanable = true;
  @Input() searchable = true;
  @Input() width = '110px';
  @Input() isRequired = false;

  @Output() changeValue = new EventEmitter<WidgetSelectValue>();

  widthLabel: string;
  showLoader: boolean;
  currentValueUUID: string;

  ngOnChanges(): void {
    this.showLoader = true;
    this.currentValueUUID = this.selectedValue?.uuid;

    // if (this.width) {
    //   this.widthLabel = this.width; //(this.width - 55) + 'px';
    // }

    setTimeout(() => this.showLoader = false);
  }

  changeSelectedValue(currentUUID: string) {
    const currentValue = this.items?.find((i) => i.uuid === currentUUID);
    this.changeValue.emit(currentValue);
  }
}

export interface WidgetSelectValue {
  uuid: string;
  label: string;
}
